/**
 * Text-normalization utilities used across all client-facing forms.
 */

/**
 * Auto-capitalize a name: capitalize each word, keep accents / apostrophes / hyphens.
 * Ex: "jean-pierre de la fontaine" -> "Jean-Pierre De La Fontaine"
 *     "l'HAŸ-les-roses"            -> "L'Haÿ-Les-Roses"
 */
export function capitalizeName(str) {
  if (!str) return "";
  return String(str)
    .toLocaleLowerCase("fr-FR")
    .replace(/(^|[\s\-'’])([\p{L}])/gu, (_, sep, ch) => sep + ch.toLocaleUpperCase("fr-FR"));
}

/**
 * Normalize an email to lowercase (no trimming — the caller controls that).
 * Kept as a helper so all forms use the exact same transformation.
 */
export function lowerEmail(str) {
  if (!str) return "";
  return String(str).toLowerCase();
}
